import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=31df732c&scoped=true&"
import script from "./bindPhone.vue?vue&type=script&lang=js&"
export * from "./bindPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindPhone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bindPhone.vue?vue&type=style&index=1&id=31df732c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df732c",
  null
  
)

export default component.exports